console.log('✅ home-page-top-carousel-wide-grey.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';

import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

let _tempTextTranslator = null;
export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

let _tempLinksTranslator = null;
export async function initTempLinksTranslator(lang) {
  _tempLinksTranslator = await initLinksTranslator(lang);
}

export async function buildComponentHomePageTopCarouselWideGrey() {
  console.log(
    `🔄 Building Component: HomePageTopCarouselWideGrey - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    await initTempTextTranslator(appState.SiteLanguageCookie);
    await initTempLinksTranslator(appState.SiteLanguageCookie);
    // const tempTranslator = await loadTextTranslations(lang);

    // Destructure just the keys you need, giving them your desired local names
    const {
      keyFindManufacturers: lblFindManufacturers,
      keyAndWholesalersGlobally: lblAndWholesalersGlobally,
      keyHomePageCarouselContentBody: lblHomePageCarouselContentBody,
      keyViewAllProducts: lblViewAllProducts,
    } = _tempTextTranslator;

    const { keyProducts: linkViewAllProducts } = _tempLinksTranslator;

    const imgDefaultSrcStarterPath = `${APP_CONFIG.IMAGES_BASE_URL}`;
    //const bannerImagePath1 = `${imgDefaultSrcStarterPath}imgs/homecur/banner_img_01.jpg`;
    //const bannerImagePath2 = `${imgDefaultSrcStarterPath}imgs/homecur/purse.png`;
    //const bannerImagePath3 = `${imgDefaultSrcStarterPath}imgs/homecur/banner_img_03.jpg`;
    //const bannerImagePath4 = `${imgDefaultSrcStarterPath}imgs/homecur/dress2.png`;
    //const bannerImagePath5 = `${imgDefaultSrcStarterPath}imgs/homecur/pots.png`;

    const bannerImagePath1 = `${imgDefaultSrcStarterPath}imgs/homecur/banner_img_01-640.webp`;
    const bannerImagePath2 = `${imgDefaultSrcStarterPath}imgs/homecur/purse2-1280.webp`;
    const bannerImagePath3 = `${imgDefaultSrcStarterPath}imgs/homecur/banner_img_03-1280.webp`;
    const bannerImagePath4 = `${imgDefaultSrcStarterPath}imgs/homecur/dress2-1280.webp`;
    const bannerImagePath5 = `${imgDefaultSrcStarterPath}imgs/homecur/pots-1280.webp`;

    const imgIconDown = `${imgDefaultSrcStarterPath}imgs/icons/svg/arrow-down4.svg`;

    const slidesSectionType1 = ` <div class="comingsoon-video-container-iframe" id="crossfade">
        <img src="${bannerImagePath1}" width="524" height="379" class="bannerImageForIframeContainer" alt="Image 1" loading="eager" fetchpriority="high" decoding="async">
            <img src="${bannerImagePath2}" width="524" height="379" class="bannerImageForIframeContainer" alt="Image 2" loading="eager" fetchpriority="high" decoding="async">
                <img src="${bannerImagePath3}" width="524" height="379" class="bannerImageForIframeContainer" alt="Image 3" loading="eager" fetchpriority="high" decoding="async">
                    <img src="${bannerImagePath4}" width="524" height="379" class="bannerImageForIframeContainer" alt="Image 4" loading="eager" fetchpriority="high" decoding="async">
                        <img src="${bannerImagePath5}" width="524" height="379" class="bannerImageForIframeContainer" alt="Image 5" loading="eager" fetchpriority="high" decoding="async">

                        </div>`;

    const slidesSectionType2 = ` <div class="comingsoon-video-container-iframe" id="crossfade-static">

    

                                            <img src="${bannerImagePath1}" width="524" height="379" class="bannerImageForIframeContainer" alt="Image 1" loading="eager" fetchpriority="high" decoding="async">
                                           
     
    </div>`;

    function responsiveWebp(name, alt) {
      const base = `/imgs/homecur/${name}`;
      const variants = [320, 640, 1280];
      const srcset = variants.map(w => `${base}-${w}.webp ${w}w`).join(', ');
      // Adjust sizes to your layout
      const sizes = '(max-width: 640px) 100vw, 640px';

      return `
    <picture>
      <source 
        type="image/webp" 
        srcset="${srcset}" 
        sizes="${sizes}">
      <img 
        src="${base}-1280.webp" 
        srcset="${srcset}" 
        sizes="${sizes}"
        class="bannerImageForIframeContainer"
        alt="${alt}"
        loading="eager" 
         fetchpriority="high"
        decoding="async">
    </picture>
  `;
    }

    // Generate the HTML structure
    const html = `
            <div class="homePage-banner1-Container-wrapper">
                <center>
                    <div class="comingsoon-flex-container">
                        <div class="comingsoon-flex-container-grid">
                            <div class="navigate-wrapper-left"></div>
                            <div class="navigate-wrapper-center">
                                <div class="comingsoon-flex-container-content-grid">
                                    <div class="comingsoon-flex-item-left">
                                        <div class="homePage-banner1-Container">
                                            <div class="homePage-banner1-HeaderText-Container">
                                                <h1>
                                                    <span class="titleMainHeader">${lblFindManufacturers}</span>
                                                    <span class="titleMainSubHeader">${lblAndWholesalersGlobally}</span>
                                                </h1>
                                                <p>${lblHomePageCarouselContentBody}</p>
                                            </div>
                                            <div class="homePage-banner1-Buttons-Container">
                                                <a href="${linkViewAllProducts}" class="comingsoon-FindOutMore-Btn">
                                                    ${lblViewAllProducts}
                                                </a>
                                                <div class="clearFix"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="comingsoon-flex-item-right">
                                       <div class="comingsoon-video-container-iframe">
                                         ${slidesSectionType1}
    

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </center>
                <div class="homePage-banner1-ExploreMore-Container">
                    <div id="linkExploreMore" class="homePage-banner1-ExploreMore-scroll-btn">
                        <span class="homePage-banner1-ExploreMore-scroll-btn-text"></span>
                        <span id="arrowToViewTrendingProducts" class="homePage-banner1-ExploreMore-scroll-btn-arrow">
                        <svg fill="#000" height="15" width="15" viewBox="0 0 330 330" stroke="#fff" stroke-width="33" xmlns="http://www.w3.org/2000/svg">
    <path d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
             c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150
             c2.813,2.813,6.628,4.393,10.606,4.393s7.794-1.581,10.606-4.394l149.996-150
             C331.465,94.749,331.465,85.251,325.607,79.393z"></path>
  </svg>
                         
                        </span>
                    </div>
                </div>
            </div>
        `;

    registerEventListenerToAttach(async () => attachEventListenersHomePageFeaturedProducts());

    console.log('✅ HomePageTopCarouselWideGrey built successfully.');
    return html;
  } catch (error) {
    console.error('❌ Error building HomePageTopCarouselWideGrey:', error);
    return '<div>Carousel could not be loaded.</div>';
  }
}

export function attachEventListenersHomePageFeaturedProducts() {
  const imgDefaultSrcStarterPath = `${APP_CONFIG.IMAGES_BASE_URL}`;
  const bannerImagePath1 = `${imgDefaultSrcStarterPath}imgs/homecur/banner_img_01.jpg`;
  const bannerImagePath2 = `${imgDefaultSrcStarterPath}imgs/homecur/purse.png`;
  const bannerImagePath3 = `${imgDefaultSrcStarterPath}imgs/homecur/banner_img_03.jpg`;
  const bannerImagePath4 = `${imgDefaultSrcStarterPath}imgs/homecur/dress2.png`;
  const bannerImagePath5 = `${imgDefaultSrcStarterPath}imgs/homecur/pots.png`;

  const arrowToViewTrendingProducts = document.getElementById('arrowToViewTrendingProducts');

  //const htmlComingsoon = `
  //                                        <img src="${bannerImagePath1}" class="bannerImageForIframeContainer" alt="Image 1">
  //                                        <img src="${bannerImagePath2}" class="bannerImageForIframeContainer" alt="Image 2">
  //                                        <img src="${bannerImagePath3}" class="bannerImageForIframeContainer" alt="Image 3">
  //                                        <img src="${bannerImagePath4}" class="bannerImageForIframeContainer" alt="Image 4">
  //                                        <img src="${bannerImagePath5}" class="bannerImageForIframeContainer" alt="Image 5">
  //                                   `;

  //const elementComingsoon = document.querySelector('.comingsoon-video-container-iframe');
  //if (elementComingsoon) {
  //    elementComingsoon.innerHTML = htmlComingsoon;
  //}

  if (arrowToViewTrendingProducts) {
    arrowToViewTrendingProducts.addEventListener('click', () => {
      const elementTrendingProductsDiv = document.getElementById('HomePageDivTrendingListingTitle');

      if (elementTrendingProductsDiv) {
        elementTrendingProductsDiv.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  }
}
